/**
 * Utilitaire pour afficher les noms de joueurs
 */

/**
 * AFFICHAGE COURT (pour écrans avec peu de place)
 * Priorité : Prénom > Nom > "Joueur 1/2"
 * Affiche UNIQUEMENT le prénom si disponible, même si le nom est renseigné
 * 
 * @param {Object} match - L'objet match
 * @param {string} joueur - "J1" ou "J2"
 * @returns {string} - Le prénom ou le nom du joueur
 * 
 * Exemples :
 * - Prénom: "Roger", Nom: "Federer" → "Roger"
 * - Prénom: "", Nom: "Federer" → "Federer"
 * - Prénom: "Roger", Nom: "" → "Roger"
 * - Prénom: "", Nom: "" → "Joueur 1"
 */
export function getPlayerDisplayName(match, joueur) {
  if (joueur === "J1") {
    return match.prenomJoueur1 || match.joueur1Nom || "Joueur 1";
  } else {
    return match.prenomJoueur2 || match.joueur2Nom || "Joueur 2";
  }
}

/**
 * AFFICHAGE COMPLET (pour liste des matchs, exports, etc.)
 * Priorité : Prénom + Nom > Nom > Prénom > "Joueur 1/2"
 * 
 * @param {Object} match - L'objet match
 * @param {string} joueur - "J1" ou "J2"
 * @returns {string} - Le nom complet du joueur
 * 
 * Exemples :
 * - Prénom: "Roger", Nom: "Federer" → "Roger Federer"
 * - Prénom: "", Nom: "Federer" → "Federer"
 * - Prénom: "Roger", Nom: "" → "Roger"
 * - Prénom: "", Nom: "" → "Joueur 1"
 */
export function getPlayerFullName(match, joueur) {
  if (joueur === "J1") {
    const prenom = match.prenomJoueur1 || "";
    const nom = match.joueur1Nom || "";
    
    if (prenom && nom) {
      return `${prenom} ${nom}`;  // Prénom + Nom
    } else if (nom) {
      return nom;  // Nom seul
    } else if (prenom) {
      return prenom;  // Prénom seul
    } else {
      return "Joueur 1";  // Aucun des deux
    }
  } else {
    const prenom = match.prenomJoueur2 || "";
    const nom = match.joueur2Nom || "";
    
    if (prenom && nom) {
      return `${prenom} ${nom}`;  // Prénom + Nom
    } else if (nom) {
      return nom;  // Nom seul
    } else if (prenom) {
      return prenom;  // Prénom seul
    } else {
      return "Joueur 2";  // Aucun des deux
    }
  }
}